import * as React from "react";
import { reducer, initState } from "../../../../reducers/report/oa";
import { Loading } from "../../../../../../react-components/lu-component/src/index";
import { ConfirmBox } from "../../../../components/parts/confirm-box";
import { get, makeError } from "../../../../lib/request";
import { v3ApiEndpoint } from "../../../../../../server/router/endpoint";
import { useParams } from "react-router-dom";
import { GetOAReportResponse } from "../../../../../../server/types/request/report/oa";
import { OAReportLatestPage } from "../../../../components/pages/report/latest/oa-report";
import { RetestMenu } from "../../../../components/pages/report/common";

export const OAReportContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const { loading, info, ...targetProps } = state;
	const { jobId, activityId } = useParams<{
		jobId: string;
		activityId: string;
	}>();
	React.useEffect(() => {
		get<GetOAReportResponse>(`${v3ApiEndpoint.oaReport}/${jobId}`)
			.then((response) => {
				dispatch({ type: "loadData", payload: response.data });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [jobId]);
	return (
		<>
			<Loading loading={loading} />
			{targetProps.job && targetProps.job.retestJobId && (
				<RetestMenu activityId={activityId} jobId={targetProps.job.retestJobId.toString()} page={"oa"} />
			)}
			<ConfirmBox info={info} />
			{!!targetProps.data.length && <OAReportLatestPage {...targetProps} />}
		</>
	);
};
